import { useUser } from '@clerk/clerk-react'
import { useNavigate } from 'react-router-dom'
import Layout from '../components/Layout'
import { PageHeader, StatCard, ActionCard, Section, Card } from '../components/UIComponents'

export default function Dashboard() {
  const { user, isLoaded } = useUser()
  const navigate = useNavigate()

  if (!isLoaded) {
    return (
      <Layout>
        <div className="flex items-center justify-center min-h-[60vh]">
          <div className="text-center space-y-4">
            <div className="w-12 h-12 mx-auto bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center animate-spin">
              <span className="text-white font-black text-xs">OTD</span>
            </div>
            <p className="text-slate-400">Cargando dashboard...</p>
          </div>
        </div>
      </Layout>
    )
  }

  return (
    <Layout>
      <div className="space-y-8 max-w-7xl mx-auto">
        {/* Header */}
        <PageHeader
          icon="📊"
          title="Dashboard"
          description={`Bienvenido, ${user?.firstName || 'Usuario'}! Aquí está tu resumen.`}
        />

        {/* Stats Grid */}
        <Section title="Resumen Rápido">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <StatCard
              icon="💰"
              label="Balance Total"
              value="$0.00"
              change="0%"
              changeType="up"
            />
            <StatCard
              icon="📤"
              label="Enviados Hoy"
              value="$0.00"
              change="0"
              changeType="down"
            />
            <StatCard
              icon="📥"
              label="Recibidos Hoy"
              value="$0.00"
              change="0"
              changeType="up"
            />
            <StatCard
              icon="🏆"
              label="Rewards Totales"
              value="0 pts"
              change="0%"
              changeType="up"
            />
          </div>
        </Section>

        {/* Quick Actions */}
        <Section title="Acciones Rápidas">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <ActionCard
              icon="📤"
              title="Enviar"
              description="Envía fondos a otro usuario"
              onClick={() => navigate('/send')}
            />
            <ActionCard
              icon="📥"
              title="Recibir"
              description="Recibe fondos de otros"
              onClick={() => navigate('/receive')}
            />
            <ActionCard
              icon="🔍"
              title="Descubrir"
              description="Explora nuevas oportunidades"
              onClick={() => navigate('/discover')}
            />
            <ActionCard
              icon="💰"
              title="Ganar"
              description="Gana recompensas"
              onClick={() => navigate('/earn')}
            />
            <ActionCard
              icon="🛍️"
              title="Tienda"
              description="Accede a la tienda de OTD"
              onClick={() => navigate('/store')}
            />
            <ActionCard
              icon="📱"
              title="Apps"
              description="Aplicaciones disponibles"
              onClick={() => navigate('/apps')}
            />
          </div>
        </Section>

        {/* Recent Activity */}
        <Section title="Actividad Reciente">
          <Card>
            <div className="text-center py-8">
              <p className="text-slate-400">No hay actividad reciente</p>
              <p className="text-slate-500 text-sm mt-2">
                Tus transacciones aparecerán aquí
              </p>
            </div>
          </Card>
        </Section>

        {/* Info Card */}
        <div className="bg-gradient-to-r from-blue-900/30 to-purple-900/30 border border-blue-800/50 rounded-lg p-6">
          <div className="space-y-2">
            <h3 className="text-lg font-bold text-blue-300">🚀 Open The Doorz</h3>
            <p className="text-slate-300 text-sm">
              Infraestructura Web3 serverless. Conecta, envía, y gana con tus amigos.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  )
}
